export enum CoordinateSystem {
  Geographic = "geographic",
  Utm = "utm",
  Ntm = "ntm",
}
